import { parseEventLogs, type Log } from 'viem';
import { runnerHookAbi, runnerPrizesAbi } from '@runner/sdk/abis';
import type { TxView } from '../types';

/** Use the swap's receipt, not the window seen before the wallet opened. No extra RPC reads. */
export function tradeEvidence(logs: Log[], hook: string, prizes: string): TxView['influence'] {
  const swaps = parseEventLogs({ abi: runnerHookAbi, logs: logs.filter(l => l.address.toLowerCase() === hook.toLowerCase()), eventName: 'SwapRecorded', strict: true });
  if (swaps.length !== 1) return undefined;
  const swap = swaps[0].args;
  const entries = parseEventLogs({ abi: runnerPrizesAbi, logs: logs.filter(l => l.address.toLowerCase() === prizes.toLowerCase()), eventName: 'EntryRecorded', strict: true });
  return { window: Number(swap.window), runnerDelta: swap.runnerDelta.toString(), participant: swap.participant,
    shoeEntry: entries.some(e => e.args.participant.toLowerCase() === swap.participant.toLowerCase()) };
}
